import { TOGGLE_OPTIONAL_TEXT, CHANGE_TEXT } from './constants';
import { changePreviewHiddenComponents } from '../../actions';
export const toggleOptional = (isChecked, componentIdent) => (dispatch) => {
    dispatch({
        type: TOGGLE_OPTIONAL_TEXT,
        isHidden: !isChecked,
        componentIdent,
    });
    dispatch(changePreviewHiddenComponents());
};
export const changeText = (content, componentIdent) => ({
    type: CHANGE_TEXT,
    content,
    componentIdent,
});
//# sourceMappingURL=actions.js.map